// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fe58f660","453":"67a27c0f","455":"b30f94ad","977":"218134c5"}[chunkId] + ".chunk.js";
};